import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {NgxSmartModalService} from 'ngx-smart-modal';
import {UserService} from '../../../../services/user.service';
// TODO(RZ-2562): Replace legacy VO types (PolicyUserVO) with SDK equivalents
import {PolicyUserVO} from '../../../../generate/TopLevelDomainVO';
import {UserObject} from '@iana-rzms/bff-sdk';
import {UtilService} from '../../../../util/util.service';
import {whitelistCharacterValidator} from '../../../../validators/valid-character-validator.directive';
import {requiredFieldValidator} from '../../../../validators/required-field-validator.directive';
import {emailValidator} from '../../../../validators/email-validator.directive';
import {ChangeRequestService} from "../../../../services/change-request.service";
import {catchError} from "rxjs/operators";
import {HttpErrorResponse} from "@angular/common/http";
import {of} from "rxjs";

@Component({
    selector: 'add-user-modal',
    templateUrl: './auth-policy-add-user-modal.component.html',
    styleUrls: ['./auth-policy-add-user-modal.component.scss'],
    standalone: false
})
export class AuthPolicyAddUserModalComponent implements OnInit {

  userForm: FormGroup;

  userFormErrors: any;

  @Input()
  users: PolicyUserVO[];

  @Output()
  userVOOutput = new EventEmitter<PolicyUserVO>();
  foundUser = false;
  foundUserValue: UserObject;
  formSubmitted: boolean;

  get firstName(): FormControl { return this.userForm.get('firstName') as FormControl; }
  get lastName(): FormControl { return this.userForm.get('lastName') as FormControl; }

  constructor(
      private formBuilder: FormBuilder,
      private util: UtilService,
      private userService: UserService,
      private changeRequestService: ChangeRequestService,
      public ngxSmartModalService: NgxSmartModalService) {
  }

  ngOnInit() {
    this.createUserForm();
    this.userFormErrors = null;
  }

  userFormSubmit() {
    this.userFormErrors = null;
    const email: string = this.userForm.getRawValue().email;
    this.getUserByEmail(email.trim());
  }

  private createUserForm() {
    this.foundUser = false;
    this.formSubmitted = false;
    this.foundUserValue = {};
    this.userFormErrors = null;
    this.userForm = this.formBuilder.group({
      firstName: new FormControl('', [requiredFieldValidator, whitelistCharacterValidator]),
      lastName: new FormControl('', [requiredFieldValidator, whitelistCharacterValidator]),
      email: new FormControl('', [requiredFieldValidator, emailValidator]),
    });

  }

  getUserByEmail(email: string) {
    this.userService.getTldManagerUserByEmail(email)
      .pipe(catchError((error1: HttpErrorResponse) => {
        console.log(error1);
        return of(null);
      }))
      .subscribe((data) => {
        if (data != null) {
          if (this.userExists(data.id)) {
            this.userFormErrors = {
              message: 'User already exists'
            }
            this.userForm.setErrors({'invalid': true});
          } else {
            this.foundUser = true;
            this.foundUserValue = data;
          }
        } else {
          this.foundUser = false;

        }
        this.formSubmitted = this.userFormErrors == null;
    });
  }

  proceed() {
    if (this.foundUser) {
      this.proceedWithFoundUser();
    } else {
      this.proceedWithInvitingUser();
    }

  }

  proceedWithInvitingUser() {
    const userVO: UserObject = {
      email: this.userForm.getRawValue().email,
      firstName: this.userForm.getRawValue().firstName,
      lastName: this.userForm.getRawValue().lastName,
      roles: ['TLD_MANAGER']
    };
    this.userService.inviteUser(userVO).pipe(
      catchError(error => {
        this.userFormErrors = error;
        return of(null);
      })
    ).subscribe(response => {
      // API returns 204 No Content, so we need to fetch the created user by email to get the ID
      if (!this.userFormErrors) {
        this.userService.getTldManagerUserByEmail(userVO.email)
          .pipe(
            catchError((error: HttpErrorResponse) => {
              this.userFormErrors = {
                message: 'User was created but could not be retrieved. Please try again or contact support.'
              };
              return of(null);
            })
          )
          .subscribe((data) => {
            if (data != null) {
              this.outputUser(data);
            } else if (!this.userFormErrors) {
              // If still null, set an error
              this.userFormErrors = {
                message: 'User was created but could not be retrieved. Please refresh and try again.'
              };
            }
          });
      }
    })
  }

  proceedWithFoundUser() {
    if (['EXPIRED'].includes(this.foundUserValue.status)) {
      this.changeRequestService.resendUserInvitation(this.foundUserValue.id, this.foundUserValue.email)
          .subscribe(_ => {}, error => this.userFormErrors = error);
    }
    this.outputUser(this.foundUserValue);
  }

  outputUser(userVO: UserObject) {
    const user: PolicyUserVO = {};
    user.id = userVO.id;
    user.email = userVO.email;
    user.firstName = userVO.firstName;
    user.lastName = userVO.lastName;
    this.userVOOutput.emit(user);
    this.createUserForm();
  }

  displayValidationError(controlName: string): boolean {
    return this.util.displayValidationError(this.userForm, controlName);
  }

  userExists(userID: string) {
    return this.users.some(user => user.id === userID);
  }

  close() {
    this.createUserForm();
    this.ngxSmartModalService.getModal('myModal').close();
  }

  goBack() {
    this.userFormErrors = null;
    this.formSubmitted = false;
    this.foundUser = false;
    this.foundUserValue = {};
  }

}
